import React, { useEffect, useContext } from "react"
import {
    Container,
    Card,
    CardBody
} from "reactstrap"
import BulkImport from './components/BulkImport'
import { GeneralContext } from '../../context/'

const Import = () => {
    const generalContext = useContext(GeneralContext)
    const { setBreadcrumb } = generalContext

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Clientes`,
            parentLink: '/customers',
            item: `Importar Clientes`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Card>
                        <CardBody>
                            <BulkImport />
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Import